import _ from 'lodash';

import DefaultDialogController from 'utils/notifications/default-dialog-controller';

import template from './manage-sms-notification-dialog.html';

class ManageSmsDialogController extends DefaultDialogController {
  constructor() {
    super();
    this.visibleCategories = Object.keys(this.categories || []).reduce((reduced, key) => {
      reduced[this.categories[key].id] = true;
      return reduced;
    }, {});
  }

  categoryIsVisible(category) {
    if (this.canEdit) {
      return true;
    }
    return _.find(category.subscriptions, { sendSms: true });
  }

  toggleCategory(categoryId) {
    this.visibleCategories[categoryId] = !this.visibleCategories[categoryId];
  }

  apply(categories) {
    this.applyCategories(categories);
    this.close();
  }
}

function manageSmsNotificationDialog(deps, model, params) {
  const { categories, canEdit, applyCategories, userName } = params;
  deps.Notifications.showComplexDialog({
    template,
    controller: ManageSmsDialogController,
    resolve: {
      categories: () => categories,
      canEdit: () => canEdit,
      userName: () => userName,
      applyCategories: () => applyCategories,
    },
  });

  return Promise.resolve(model);
}

export default {
  manageSmsNotificationDialog,
};



// WEBPACK FOOTER //
// ./src/modules/sms/components/manage-sms-notification/components/manage-sms-notification-dialog/manage-sms-notification-dialog-logic.js